import * as React from 'react';
import { merge } from '../../helpers/Utility';
import { withField } from './withField';

interface InjectedProps {
  value: string;
  onChange: (v: string) => void;
}

interface TextAreaInputProps {
  name: string;
  placeholder?: string;
  className?: string;
  rows?: number;
}

export const TextAreaInput: React.FC<TextAreaInputProps & InjectedProps> = ({
  className,
  name,
  onChange,
  value,
  placeholder,
  rows = 3,
  ...props
}) => {
  return (
    <div className="mt-1 flex rounded-md shadow-sm text-primary-std">
      <textarea
        {...props}
        name={name}
        id={name}
        rows={rows}
        className={merge(
          'rounded-md focus:ring-primary-500 bg-primary-std focus:border-primary-500 flex-1 min-w-0 block w-full sm:text-sm border-primary-std',
          className
        )}
        placeholder={placeholder}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
    </div>
  );
};

export const TextAreaFieldWithOptionalLabel = withField(TextAreaInput);
export const TextAreaField = withField<string, TextAreaInputProps>(TextAreaInput);
